import axios from 'axios'

const N8N_TOKEN = 'eyJhbGciOiJIUzI1NiJ9.eyJ1c2VyX2lkIjoiODkyMzc4OTQ0OTI3OSIsInVzZXJuYW1lIjoibW9zYWljbyIsImVtYWlsIjoidGVjaG5pY2FsQG1vc2FpY29lZC5jb20iLCJpYXQiOjE3NTU0NjMzMTJ9.3Zuu6tlDPjY__rFKAxR2JolmlGj53i3lgNN2om2Mj9w'
const N8N_PROJECT_URL = 'https://ai.mosaicoed.com/webhook/e9475abd-b2db-49f3-8414-fe792d65a783'
const N8N_SESSION_MEETINGS_URL = 'https://ai.mosaicoed.com/webhook/51f0d83d-4387-4e49-9d08-ef93e0757544'

export const askAI = async (payload: any): Promise<any | undefined> => {
  try {
    const response = await axios.post(N8N_PROJECT_URL, payload, {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${N8N_TOKEN}`
      },
      timeout: 120000
    })

    return {
      message: 'AI call executed successfully',
      response: response.data
    }
  } catch (error: any) {
    console.error('Error calling N8N ask_ai:', error)
    throw error
  }
}

export const generateLessonPlanWithAI = async (payload: any): Promise<any> => {
  try {
    const response = await axios.post(N8N_SESSION_MEETINGS_URL, payload, {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${N8N_TOKEN}`
      },
      timeout: 120000
    })

    if (response.data.success !== undefined) {
      return response.data
    }

    return {
      success: true,
      ...response.data
    }
  } catch (error: any) {
    console.error('Error calling N8N plan_meetings:', error)

    if (error.response) {
      const errorData = error.response.data
      const errorMessage = errorData?.message || errorData?.error || error.response.statusText
      throw new Error(`N8N API error: ${errorMessage}`)
    } else if (error.request) {
      throw new Error('No N8N API response. Check your connection.')
    } else {
      throw new Error(`Error configuring request: ${error.message}`)
    }
  }
}
